import React from 'react';
import './App.css';
import Home from './Home.js';
import "animate.css/animate.min.css";
import styled from 'styled-components';

const Header = styled.header`
  background-color: white;
`;

function App() {
  return (
    <div className="App">
      <Header className="App-header">
        <Home />
      </Header>
    </div>
  );
}

export default App;
